import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import Button from 'components/Button';
import { usePermissionService } from 'services/permission';
import { Permission } from 'types/permission';
import styles from './Permission.module.scss';

interface DeletePermissionModalProps {
  show: boolean;
  onHide: () => void;
  permission: Permission | null;
  onSuccess: (id: string) => void;
  onError: (message: string) => void;
}

const DeletePermissionModal: React.FC<DeletePermissionModalProps> = ({
  show,
  onHide,
  permission,
  onSuccess,
  onError,
}) => {
  const permissionService = usePermissionService();
  const [loading, setLoading] = useState(false);

  const handleDelete = async () => {
    if (!permission) return;

    setLoading(true);
    try {
      await permissionService.deletePermission(permission.id);
      onSuccess(permission.id);
    } catch (error) {
      console.error('Failed to delete permission:', error);
      onError('Failed to delete permission. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Delete Permission</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Are you sure you want to delete the permission{' '}
          <strong>{permission?.name}</strong> ({permission?.key})?
        </p>
        <p className="text-danger">This action cannot be undone.</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline" onClick={onHide} disabled={loading}>
          Cancel
        </Button>
        <Button
          onClick={() => void handleDelete()}
          disabled={loading}
          className={styles.deleteButton}
        >
          {loading ? 'Deleting...' : 'Delete'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeletePermissionModal;
